import React, { useState } from "react";
import apiHelper from "../../../../util/ApiHelper";
import { Link } from "react-router-dom";
import { useLoading } from "../../../../util/LoadingProvider";
import { Box, Grid, Typography } from "@material-ui/core";
import { toast } from "react-toastify";
import { modal } from "../../../../util";
import RefundVenueSettingsForm from "./refundVenueSettingsForm";
import DragAndDropTable from "../../../common/DragAndDropTable";

export default function RefundVenueSettingsPage(props) {
  const { disabled, match } = props;
  const [globalFilter, setGlobalFilter] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [orderingDisabled, setOrderingDisabled] = useState(false);
  const [rows, setRows] = useState([]);
  const [searchString, setSearchString] = useState("");
  const { setLoading } = useLoading();
  const [pageSize, setPageSize] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const getRefundVenues = React.useCallback(async () => {
    try {
      setLoading(true);
      const result = await apiHelper.hkiff.getRefundVenues(
        null,
        pageIndex,
        (pageIndex + 1) * pageSize,
        pageSize,
        searchString
      );
      console.log(result);
      setRows(result.data.content.filter((x) => x));
      setTotalElements(result.data.totalElements);
      setTotalPages(result.data.totalPages);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [pageIndex, pageSize, searchString, setLoading]);

  React.useEffect(() => {
    if (pageSize) getRefundVenues();
  }, [getRefundVenues]);

  const handleSorting = (bool) => {
    if (!isSearched) {
      setOrderingDisabled(bool);
    }
  };

  const handleSearch = (searchString) => {
    setGlobalFilter(searchString);
    setIsSearched(true);
    setOrderingDisabled(true);
  };

  const saveOrdering = async () => {
    try {
      await apiHelper.hkiff.orderRefundVenues(rows.map((e) => e.id));
      toast.dark("Your changes is saved.");
      await getRefundVenues();
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async (row) => {
    const decision = await modal.fire({
      title: "Delete Venue",
      text: "Are you sure to delete this venue?",
      showCancelButton: true,
      confirmButtonText: `Delete`,
    });
    if (decision.isConfirmed) {
      try {
        const result = await apiHelper.hkiff.deleteRefundVenueById(row.id);
        if (result.status === 200) {
          toast.dark("The venue is deleted.");
          await getRefundVenues();
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Venue Name (English)",
        accessor: "localizations.en.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.en.name}
            </Link>
          );
        },
      },
      {
        Header: "Venue Name (Traditional Chinese)",
        accessor: "localizations.tc.name",
        Cell: ({ row }) => {
          return (
            <Link
              style={{
                textDecoration: "none",
                color: "#306F9D",
              }}
              to={`${match.url}/${row.original.id}`}
            >
              {row.original.localizations.tc.name}
            </Link>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Refund &gt; Venue Settings
        </Typography>
      </Box>
      <Grid container spacing={4}>
        <Grid item xs={4}>
          <RefundVenueSettingsForm
            description="Add New Venue"
            submitBtnTxt="Add New Venue"
            gridSize={4}
            upperBtnGroupSize="75%"
            fetchData={getRefundVenues}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={8}>
          <DragAndDropTable
            globalFilter={globalFilter}
            orderingDisabled={orderingDisabled}
            handleSorting={handleSorting}
            handleSearch={handleSearch}
            searchString={searchString}
            setSearchString={setSearchString}
            fetchData={getRefundVenues}
            data={rows}
            setData={setRows}
            columns={columns}
            bulkDeleteApi={(ids) => Promise.all(ids.map((id) => apiHelper.hkiff.deleteRefundVenueById(id)))}
            subject="venue"
            saveOrderingApi={saveOrdering}
            disabled={disabled}
            withPagination={true}
            editDeleteAction={true}
            handleDelete={handleDelete}
            deleteByRow={true}
            setParentPageSize={setPageSize}
            setParentPageIndex={setPageIndex}
            parentPageIndex={pageIndex}
            totalElements={totalElements}
            totalPages={totalPages}
          />
        </Grid>
      </Grid>
    </>
  );
}
